import { Divider, Flex, Image } from '@chakra-ui/react';
import { Children } from 'react';

import poweredByRevelioLabs from '../assets/images/revlio/powered-by-revelio-labs.svg';
import { useBrand } from '../shared/branding/brand-provider';
import { FreeTrialAlertModal } from './trialUser/FreeTrialAlertModal';
import { useFreeTrialAlertModalState } from './trialUser/useFreeTrialAlertModalState';

export const PoweredByRevelioLabsLogo = () => {
  const { clientName } = useBrand();

  if (clientName === 'default') return null;

  return (
    <a href="https://www.reveliolabs.com/" target="_blank" rel="noreferrer">
      <Image
        src={poweredByRevelioLabs}
        alt="Powered by Revelio Labs"
        height="15px"
      />
    </a>
  );
};

export const GlobalTopRightContent = ({
  children,
  showPoweredBy,
}: {
  children?: React.ReactNode;
  showPoweredBy?: boolean;
}) => {
  const { showTrialChip, days, hours } = useFreeTrialAlertModalState();
  const { clientName } = useBrand();

  const showPoweredByLogo = (showPoweredBy ?? true) && clientName !== 'default';
  const hasTrailingContent = showTrialChip || Children.count(children) > 0;

  return (
    <Flex alignItems="center" gap={2}>
      {showPoweredByLogo && (
        <a href="https://www.reveliolabs.com/" target="_blank" rel="noreferrer">
          <Image
            src={poweredByRevelioLabs}
            alt="Powered by Revelio Labs"
            height="15px"
          />
        </a>
      )}
      {showPoweredByLogo && hasTrailingContent && (
        <Divider
          orientation="vertical"
          height="20px"
          borderColor="gray.300"
          mx={1}
        />
      )}
      {showTrialChip && (
        <div>
          <FreeTrialAlertModal days={days} hours={hours} />
        </div>
      )}
      {Children.count(children) > 0 && <div>{children}</div>}
    </Flex>
  );
};
